import PropTypes from 'prop-types';
import React from 'react';
import {
  Checkbox,
  Button,
  OverlayTrigger,
  Popover,
  Glyphicon,
} from 'react-bootstrap';
import { humanize, titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';

class ShipmentTypeFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actives: this.props.actives,
    };
  }

  onChange(value, ev) {
    const state = Object.assign({}, this.state);
    if (ev.target.checked) {
      state.actives.push(value);
    } else {
      const idx = state.actives.indexOf(value);
      state.actives.splice(idx, 1);
    }
    this.setState(state);
    this.props.onChange(state.actives);
  }

  renderPopup() {
    const { t } = this.props;
    return (
      <Popover id="shipment-types-popup">
        <ul className="filter-dropdown-wrapper">
          {this.props.items.map((shipmentType) => (
            <li key={shipmentType}>
              <Checkbox
                checked={this.props.actives.indexOf(shipmentType) > -1}
                onChange={(e) => this.onChange(shipmentType, e)}
              >
                {titleize(humanize(t(shipmentType.localizationSlug)))}
              </Checkbox>
            </li>
          ))}
        </ul>
      </Popover>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className={this.props.className}>
        <OverlayTrigger
          className={this.props.className}
          rootClose
          trigger="click"
          placement="bottom"
          overlay={this.renderPopup()}
        >
          <div>
            <Button
              bsStyle="default"
              style={{ outline: 'none' }}
              bsSize="small"
            >
              {titleize(t('SHIPMENT_TYPES'))}
              <Glyphicon glyph="chevron-down" className="button-down-glyph" />
            </Button>
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}

ShipmentTypeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  actives: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
};

export default withTranslation()(ShipmentTypeFilter);
